import React from 'react';
import EditContext from './EditContext';
import { EditContext as EditContextType } from 'types';

export interface HasEditContext {
	editContext: EditContextType;
}

// https://reactjs.org/docs/context.html#consuming-context-with-a-hoc
export default function withEditContext(WrappedComponent: React.ComponentClass<HasEditContext> & any) {
	const EditComponent: any = (props) => {
		// here we're simply
		// 1) passing down the props coming from higher components
		// 2) making sure that the context is being set as editContext

		return (
			<EditContext.Consumer>
				{(value: EditContextType) => <WrappedComponent {...props} editContext={value} />}
			</EditContext.Consumer>
		);
	};

	const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	EditComponent.displayName = `withEditContext(${wrappedComponentName})`;
	EditComponent.WrappedComponent = WrappedComponent;

	return EditComponent;
}
